import { computed } from "@vue/composition-api";
export default function missingFilogixDetails(filogixDetails, requiredKeys) {
  const missingFilogixDetailsForImport = computed(() => {
    return requiredKeys.some(key => !filogixDetails.value[key]);
  });
  return {
    missingFilogixDetailsForImport
  };
}